import React, { useState, useCallback, useEffect } from 'react';
import './Header.scss';
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Importa el hook

const Header = (props) => {
  const { t, i18n } = useTranslation(); // Función de traducción y control de idioma

  const [y, setY] = useState(window.scrollY);
  const [scrollMenu, setScroll] = useState('');
  const [logo, setLogo] = useState('/assets/Logos/svg-logo-velasur.svg');
  const navigate = useNavigate();
  const actualUrl = useLocation();

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        if (window.scrollY === 0) {
          setScroll('');
          setLogo('/assets/Logos/svg-logo-velasur.svg');
        }
      } else if (y < window.scrollY) {
        if (window.scrollY !== 0) {
          setScroll('back_menu');
          setLogo('/assets/Iconos/svg-icon-iso.svg');
        }
      }
      setY(window.scrollY);
    },
    [y]
  );

  const scrollTarget = (target) => {
    scroller.scrollTo(target, { smooth: true, duration: 700 });
  };

  const scrollToPage = (target) => {
    navigate(`/${target}`);
    scrollTarget(target.slice(1));
  };

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener('scroll', handleNavigation);

    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  const handleMenu = (type) => {
    if (type) scrollToPage(type);
    props.setOpen(props.open === 'menu-open' ? '' : 'menu-open');
  };

  const dispoTemp = () => {
    props.setOpen(props.open === 'menu-open' ? '' : 'menu-open');
    props.setImagen(true);
  };

  // Botón para cambiar idioma: alterna entre 'es' e 'en'
  const toggleLanguage = () => {
    const nextLanguage = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(nextLanguage);
  };

  return (
    <>
      <header className={`header  ${scrollMenu}`}>
        <div className='icon_menu'>
          <p className='btn-toggle' onClick={() => handleMenu()}>
            <span></span>
          </p>
          <p>{t('header.menu')}</p> {/* Texto traducido */}
        </div>

        <div className='icon_logo'>
          <a href='/'>
            <img src={logo} alt='logo' />
          </a>
        </div>

        <div className='telefono'>
  <a
    href={i18n.language === 'en' ? 'tel:+524428801675' : 'tel:4428801675'}
    target="_blank"
    rel="noopener noreferrer"
  >
    {i18n.language === 'en' 
      ? 'T. +52 (442) 880 1675' 
      : t('header.phone', { phone: '(442) 880 1675', prefix: 'T.' })}
  </a>
</div>



        <nav className='menu'>
          <ul>
            <li>
              <a href='#concepto' onClick={() => handleMenu('#concepto')}>
                {t('header.concept')}
              </a>
            </li>
            <li>
              <a>{t('header.macroproject')}</a>
              <ul>
                <li>
                  <a href='/privada-acacia'>{t('header.privadaAcacia')}</a>
                </li>
                <li>
                  <a href='/privada-artemisa'>{t('header.privadaArtemisa')}</a>
                </li>
              </ul>
            </li>
            <li>
              <a href='#masterplan' onClick={() => handleMenu('#masterplan')}>
                {t('header.availability')}
              </a>
            </li>
            <li>
              <a href='/casas-velasur' onClick={() => handleMenu()}>
                {t('header.houses')}
              </a>
            </li>
            <li>
              <a href='#ubicacion' onClick={() => handleMenu()}>
                {t('header.location')}
              </a>
            </li>
            <li>
              <a href='https://grupovelas.com.mx/' target={'_blank'}>
                <img
                  src='/assets/Logos/svg-logo-grupo-velas.svg'
                  alt={t('header.grupoVelasAlt')}
                />
              </a>
            </li>
          </ul>
        </nav>

        <div className='social-media'>
          <a
            href='https://api.whatsapp.com/send?phone=524461340798&text='
            target={'_blank'}
          >
            <img src='/assets/Logos/svg-icon-whatsapp.svg' alt='whatsapp' />
          </a>
          <a
            href='https://www.facebook.com/Velasur-by-Grupo-Velas-100278439225721/'
            target={'_blank'}
          >
            <img src='/assets/Logos/svg-icon-facebook.svg' alt='facebook' />
          </a>
          <a
            href='https://instagram.com/velasur_qro?utm_medium=copy_link'
            target={'_blank'}
          >
            <img src='/assets/Logos/svg-icon-instagram.svg' alt='instagram' />
          </a>
        </div>

        {/* Botón dinámico que cambia el texto según idioma actual */}
        <div className='language-switcher'>
  <button onClick={toggleLanguage}>
    {i18n.language === 'es' ? 'EN' : 'ES'}
  </button>
</div>

      </header>
    </>
  );
};

export default Header;
